export const loadState = () => {
  try {
    const serializedState = localStorage.getItem('status');
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const saveState = (state) => {
  try {
    console.log(state);
    const serializedState = JSON.stringify(state);
    localStorage.setItem('status', serializedState);
  } catch (err) {
    console.log(err);
  }
};
